import tokenHttpClient from "../utils/httpClient";
import { post, postFile } from "../utils/httpClients-methods";
import { API_URL } from "../utils/AppApiUrl";

export const uploadBulkAppointment = async (
  baseURL,
  requestBody,
  queryParam
) => {
  try {
    let formData = new FormData();
    if (requestBody) {
      formData.append("file", requestBody);
    }
    const uploadUserResponse = await postFile(
      tokenHttpClient,
      `${baseURL}${API_URL.uploadBulkAppointment}?vendorCode=${queryParam}`,
      formData
    );

    if (uploadUserResponse?.status === 200 && uploadUserResponse.data) {
      return uploadUserResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const getBulkFileList = async (baseURL, requestBody) => {
  try {
    const getBulkFileResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.bulkFileList}`,
      JSON.stringify(requestBody)
    );
    if (getBulkFileResponse?.status === 200 && getBulkFileResponse.data) {
      return getBulkFileResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const getBulkAppointments = async (baseURL, requestBody) => {
  try {
    const validResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.getBulkAppointments}`,
      JSON.stringify(requestBody)
    );
    if (validResponse?.status === 200 && validResponse.data) {
      return validResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const VendorBulkAppointment = async (baseUrl, request) => {
  const APIURL = `${baseUrl}${API_URL.vendorBulkAppoitmentUrl}`;
  try {
    const response = await post(
      tokenHttpClient,
      APIURL,
      JSON.stringify(request)
    );
    if (response?.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (error) {
    throw error;
  }
};
